export default {
  ruleInfo: '/activationScore/client/ruleDetail'
}
